import { Link, useLocalSearchParams } from 'expo-router';
import { useQuery } from 'urql';
import EventScorekeepingFeed, {
  type GetEventScorekeepingFeed,
} from '@/components/Event/EventScorekeeping/EventScorekeepingFeed';
import EventScorekeepingFeedItem, {
  Card,
} from '@/components/Event/EventScorekeeping/EventScorekeepingFeed/EventScorekeepingFeedItem';
import ActionBar from '@/components/UI/ActionBar';
import ActionButton from '@/components/UI/ActionButton';
import Box from '@/components/UI/Box';
import { graphql, type ResultOf } from '@/gql/graphql';

const GetEventScorekeeping = graphql(/* GraphQL */ `
  query GetEventScorekeeping($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      permissions
    }
  }
`);

export default function EventScorekeeping({ basePath }: { basePath: string }) {
  const { eventId } = useLocalSearchParams<{ eventId?: string }>();

  const [{ data }] = useQuery({
    query: GetEventScorekeeping,
    variables: { eventId: eventId || '' },
    pause: !eventId,
  });

  return (
    <Box direction="vertical" flex>
      {data?.event_by_pk?.permissions?.edit_score ? (
        <ActionBar>
          <Link
            asChild
            href={{
              pathname: `${basePath}/scorekeeping`,
              params: { eventId },
            }}
          >
            <ActionButton
              forceLabel
              label="Scorekeeper Mode"
              icon="create-outline"
              variant="secondary"
            />
          </Link>
        </ActionBar>
      ) : null}
      <EventScorekeepingFeed
        renderItem={({
          item,
        }: {
          item: ResultOf<
            typeof GetEventScorekeepingFeed
          >['badge_assignee'][number];
        }) => {
          return (
            <Card>
              <EventScorekeepingFeedItem fragment={item.badge_assignees} />
            </Card>
          );
        }}
      />
    </Box>
  );
}
